<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    scrollable
  >
    <v-card class="set-rule pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        <p class="text-body-2 grey--text font-weight-bold mt-5">
          {{ $t("confirmationDialogText1SetRule") }}
        </p>
        <v-icon
          v-if="
            item.entity_type == 'activity_page' || item.entity_type == 'scorm'
          "
          class="v-list-item__icon d-inline-block"
        >
          mdi-text
        </v-icon>
        <v-icon
          v-else-if="item.entity_type == 'quiz'"
          class="v-list-item__icon d-inline-block"
        >
          mdi-chat-question-outline
        </v-icon>
        <v-icon v-else-if="item.entity_type == 'checklist'" class="v-list-item__icon d-inline-block">
          mdi-order-bool-ascending-variant
        </v-icon>
        <v-icon v-else class="v-list-item__icon d-inline-block">
          mdi-help-box-multiple-outline
        </v-icon>
        <span class="text-body-2 pl-2 d-inline-block">{{ item.title }}</span>
        <v-radio-group v-model="ruleType">
          <v-expansion-panels class="mb-6" v-model="openedPanel">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header expand-icon="" class="pa-0">
                <v-radio color="accent" value="feedItemDependent" class="grey--text" data-testid="feed-item-dependent-radio-button"
                  ><template v-slot:label>
                    <div>
                      <span
                        class="text-subtitle-2 grey--text font-weight-bold"
                        :class="{ 'darktext--text': ruleType == 'feedItemDependent' }"
                        >{{ $t("confirmationDialogText2SetRuleFeedItem") }}</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row data-testid="feed-item-dependent-row">
                <v-col cols="12" style="margin-top: 2px;">
                  <v-form
                    ref="form1"
                    v-model="valid"
                    @keyup.enter="submitDialogBtn()"
                    @submit.prevent
                  >
                    <v-select
                      v-model="itemSelected"
                      background-color="background"
                      class="rounded-xxl select-items  my-2"
                      :items="publishedItems"
                      item-text="attributes.title"
                      item-value="id"
                      return-object
                      solo
                      append-icon="mdi-chevron-down"
                      dense
                      :menu-props="{
                        closeOnContentClick: true,
                        rounded: 'xxl',
                        maxHeight: 160,
                        maxWidth: 560,
                        contentClass: 'set-rule-menu mt-n1',
                      }"
                      data-testid= "feed-items-select"
                      :error-messages="errors"
                    >
                      <!-- eslint-disable-next-line -->
                      <template v-slot:item="{ item }">
                        <span class="text-subtitle-2 darktext--text">  {{ item.attributes.title }}</span>&nbsp;<span v-if="item.attributes.rule_available_after != null" style="font-size:12px !important;" class="text-subtitle-2 greytext--text">{{'&nbsp;(' + $t('availableAfter') + ' ' + feedItemAvailableAfter(item.attributes.rule_available_after) + ')'}}</span>
                      </template>
                    </v-select>
                  </v-form>
                </v-col>
              </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header expand-icon="" class="pa-0">
                  <v-radio color="accent" value="dateDependent" class="grey--text" data-testid="date-dependent-radio-button"
                  ><template v-slot:label>
                    <div>
                      <span
                        class="text-subtitle-2 grey--text font-weight-bold"
                        :class="{ 'darktext--text': ruleType == 'dateDependent' }"
                        >{{ $t("confirmationDialogText2SetRuleDate") }}</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row data-testid="date-dependent-row">
                <v-col cols="12">
                  <v-form
                    ref="form2"
                    v-model="valid"
                    @keyup.enter="submitDialogBtn()"
                    @submit.prevent
                  >
                  <v-row no-gutters>
                  <v-col cols="12" md="6">  
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="accent"
                        v-model="dateSelected"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        clearable
                        :rules="dateRules"
                        data-testid="date-input"
                        class="mr-3"
                      >
                        <template v-slot:prepend>
                          <v-icon color="accent">mdi-calendar</v-icon>
                        </template>
                        <template v-slot:label>
                          <div>
                            <span
                              class="text-subtitle-2 accent--text"
                              >{{ $t("chooseDate") }}</span
                            >
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="dateSelected" no-title :allowed-dates="allowedDates">
                    </v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col cols="12" md="6">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-height="200"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="accent"
                        v-model="timeSelected"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        clearable
                        :rules="timeRules"
                        data-testid="time-input"
                        class="ml-3"
                      >
                        <template v-slot:prepend>
                          <v-icon color="accent">mdi-clock-outline</v-icon>
                        </template>
                        <template v-slot:label>
                          <div>
                            <span
                              class="text-subtitle-2 accent--text"
                              >{{ $t("chooseTime") }}</span
                            >
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in time"
                        :key="index"
                        @click="timeSelected = item"
                        dense
                      >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  </v-col>
                  </v-row>
                  </v-form>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="py-0">
                  <div v-if="error" class="ml-3" data-testid="error-message">
                    <span class="error--text text-caption"> {{ error }}</span> 
                  </div>
                </v-col>
              </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header expand-icon="" class="pa-0">
                  <v-radio color="accent" value="none" class="grey--text" data-testid="no-rule-radio-button"
                  ><template v-slot:label>
                    <div>
                      <span
                        class="text-subtitle-2 grey--text font-weight-bold"
                        :class="{ 'darktext--text': ruleType == 'none' }"
                        >{{ $t("confirmationDialogText2SetRuleNone") }}</span
                      >
                    </div>
                  </template>
                </v-radio>
              </v-expansion-panel-header>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-radio-group>      
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4"
          @click="show = false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4"
          :loading="loading"
          @click="submitDialogBtn()"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";
import moment from 'moment'
import { ruleRequired } from "../rules/formRules.js";

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t("submit"),
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t("cancel"),
    },
    item: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      alertMsg: "",
      itemSelected: {
        attributes: { id: "none", is_published: true, title: i18n.t('none') },
      },
      loading: false,
      dateSelected: null,
      menu: false,
      time: Array(24 * 4)
        .fill(0)
        .map((_, i) => {
          return ("0" + ~~(i / 4) + ":0" + 60 * ((i / 4) % 1)).replace(
            /\d(\d\d)/g,
            "$1"
          );
        }),
      timeSelected: null,
      dateTimeSelected: null,
      ruleType: "none",
      error: null,
      dateRules: ruleRequired('labelDate'),
      timeRules: ruleRequired('labelTime'),
      valid: true,
      errors: [],
      openedPanel: 2
    };
  },
  watch: {
    timeSelected(val){
      if(new moment(this.dateSelected + " " + val, 'YYYY-MM-DD HH:mm').toDate() < new Date()){
        this.error = i18n.t("setRuleDateTimePastDateError")
      }else {
        this.error = null
      }
    },
    dateSelected(val){
      if(new moment(val + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate() < new Date()){
        this.error = i18n.t("setRuleDateTimePastDateError")
      }else {
        this.error = null
      }
    },
    itemSelected(val){
      if(val.attributes.id != 'none'){
        this.errors = []
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    publishedItems() {
      return this.items.filter(
        (page) =>
          page.attributes.is_published == true &&
          page.attributes.entity_id != this.item.entity_id &&
          page.attributes.entity_type != "section"
      );
    },
  },
  created() {
    this.publishedItems.unshift({
      attributes: { id: "none", is_published: true, title: i18n.t('none') },
    });
    if (this.item.rule_item_id != null) {
      this.ruleType = 'feedItemDependent'
      this.itemSelected =
        this.publishedItems[
          this.publishedItems.findIndex(
            (item) => item.id == this.item.rule_item_id
          )
        ];
      this.openedPanel = 0
    } else if(this.item.rule_available_after != null) {
      this.ruleType = "dateDependent";
      const localDate = new Date(this.item.rule_available_after)    
      this.dateSelected = moment(localDate).format('YYYY-MM-DD')
      this.timeSelected = moment(localDate).format('HH:mm')
      this.openedPanel = 1
    } else {
      this.ruleType = 'none'
      this.openedPanel = 2
    }
  },
  methods: {
    submitDialogBtn() {
     
      if(this.ruleType == "dateDependent"){
        this.valid = this.$refs.form2.validate()
        if(this.valid){
          if (this.dateSelected != null && this.timeSelected != null) {
            this.dateTimeSelected = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString()
          }
          if ((this.dateSelected != null && this.timeSelected == null) || (this.dateSelected == null && this.timeSelected != null)) {
            this.error = i18n.t("setRuleDateTimeRequiredError")
            return
          }
          if(this.error == null){
            this.loading = true;
            this.$emit(
            "proceedSubmit",
            this.ruleType,
            this.itemSelected,
            this.dateTimeSelected
          )}
        }
      }else if(this.ruleType == "feedItemDependent") {
        this.valid = this.$refs.form1.validate()
        if(this.valid){
          if(this.itemSelected.attributes.id == 'none'){
            this.errors = [i18n.t('fieldErrorRequired', { 'field': i18n.t('labelFeedItem') })]
          }else {
            this.loading = true;
            this.$emit(
            "proceedSubmit",
            this.ruleType,
            this.itemSelected,
            this.dateTimeSelected      
          )}
        }     
      }else {
        this.loading = true;
          this.$emit(
          "proceedSubmit",
          this.ruleType,
          this.itemSelected,
          this.dateTimeSelected
      )}
    },
    feedItemAvailableAfter(date){
      const localDate = new Date(date)    
      return moment(localDate).format('YYYY-MM-DD') + " " + moment(localDate).format('HH:mm')
    },
    allowedDates(val){
      return val >= new Date().toISOString().substr(0, 10)
    },
  },
};
</script>
<style scope>
.set-rule-menu .v-select-list {
  background: var(--v-background-base);
}
</style>